<template>
	<span class="match-counter" v-if="matches.length > 0">{{ count }}</span>
</template>

<script>
import { mapState } from "vuex";

export default {
	computed: {
		...mapState("UI", ["matches"]),
        count() {
            return this.matches.map(bin => bin.matches.length).reduce((acc, it) => {
                return acc = acc + it
            })
        }
	},
};
</script>

<style lang="scss" scoped>
.match-counter {
    font-size: 0.7rem;
    //line-height: 1;
    font-weight: bold;
    min-width: 14px;
    text-align: center;
    background: var(--color-bg-dark);
    border-radius: 5px;
    border: 1px solid var(--font-default-color);
    color: var(--font-default-color);
    padding: 3px 4px;
    //margin-right: 7px;
    position: absolute;
    right: 130%;
    //opacity: 0.4;
    //transform: translateX(-125%);
}
</style>
